import { createSlice } from '@reduxjs/toolkit';
import { ListShipmentsState } from './types';
import { StoreStatus } from '../../core/types/common.types';
import { listShipmentsThunk } from './thunks';

// Initial State
const initialState: ListShipmentsState = {
  errors: null,
  status: StoreStatus.IDLE,
  response: null,
};

// Slice
export const listShipmentsSlice = createSlice({
  name: 'listShipments',
  initialState,
  reducers: {
    setValues: (state, action) => ({
      ...state,
      values: action.payload,
    }),
    reset: () => ({
      ...initialState,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(listShipmentsThunk.pending.type, (state) => {
      state.status = StoreStatus.BUSY;
    });
    builder.addCase(listShipmentsThunk.fulfilled.type, (state, action: any) => {
      state.status = StoreStatus.IDLE;
      state.response = action.payload;
      state.errors = null;
    });
    builder.addCase(listShipmentsThunk.rejected.type, (state, action: any) => {
      state.status = StoreStatus.ERROR;
      state.errors = action.payload;
      state.response = null;
    });
  },
});

// Action creators
export const { reset, setValues } = listShipmentsSlice.actions;
export * from './thunks';
export * from './selectors';
export default listShipmentsSlice.reducer;
